export default {"src":"/_next/static/media/see-no-evil.1d70890b.svg","height":21,"width":21};